'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';

var hideJob = function (_a) {
    var baseUrl = _a.baseUrl, langCode = _a.langCode, jobId = _a.jobId, accessToken = _a.accessToken, appId = _a.appId, source = _a.source;
    return __awaiter(void 0, void 0, void 0, function () {
        var urlApi, res;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    urlApi = "".concat(baseUrl, "/api-gateway/v1.0/job/").concat(jobId, "/hide");
                    return [4 /*yield*/, fetch(urlApi, {
                            method: 'POST',
                            mode: 'cors',
                            headers: {
                                'Accept-Language': langCode,
                                'X-App-Id': appId,
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken)
                            },
                            body: JSON.stringify({ source: source })
                        })
                            .then(function (res) { return res.json(); })
                            .catch(function (error) { return console.error(error); })];
                case 1:
                    res = _b.sent();
                    if ((res === null || res === void 0 ? void 0 : res.code) === 0) {
                        return [2 /*return*/, {
                                data: true,
                                error: ''
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: false,
                                error: res === null || res === void 0 ? void 0 : res.message
                            }];
                    }
            }
        });
    });
};
var unhideJob = function (_a) {
    var baseUrl = _a.baseUrl, langCode = _a.langCode, jobId = _a.jobId, accessToken = _a.accessToken;
    return __awaiter(void 0, void 0, void 0, function () {
        var urlApi, res;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    urlApi = "".concat(baseUrl, "/api-gateway/v1.0/job/").concat(jobId, "/unhide");
                    return [4 /*yield*/, fetch(urlApi, {
                            method: 'POST',
                            mode: 'cors',
                            headers: {
                                'Accept-Language': langCode,
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken)
                            }
                        })
                            .then(function (res) { return res.json(); })
                            .catch(function (error) { return console.error(error); })];
                case 1:
                    res = _b.sent();
                    if ((res === null || res === void 0 ? void 0 : res.code) === 0) {
                        return [2 /*return*/, {
                                data: true,
                                error: ''
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: false,
                                error: res === null || res === void 0 ? void 0 : res.message
                            }];
                    }
            }
        });
    });
};

export { hideJob, unhideJob };
//# sourceMappingURL=services.js.map
